import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

// Attach JWT token from localStorage on every request
api.interceptors.request.use(config => {
  const token = localStorage.getItem('adeona_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Redirect to login on 401
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401 && window.location.pathname.startsWith('/admin')) {
      localStorage.removeItem('adeona_token');
      localStorage.removeItem('adeona_user');
      window.location.href = '/admin/login';
    }
    return Promise.reject(err);
  }
);

// ── Public API ────────────────────────────────────────────────
export const publicApi = {
  getCampaign: () => api.get('/campaign'),
  submitApplication: (data) => api.post('/applications', data),
  getApplicationStatus: (id) => api.get(`/applications/${id}/status`),
};

// ── Admin API ─────────────────────────────────────────────────
export const adminApi = {
  login: (credentials) => api.post('/admin/login', credentials),
  getDashboard: () => api.get('/admin/dashboard'),
  getApplications: (params) => api.get('/admin/applications', { params }),
  getApplication: (id) => api.get(`/admin/applications/${id}`),
  updateStatus: (id, status) => api.patch(`/admin/applications/${id}/status`, { status }),
  saveScore: (id, scores) => api.post(`/admin/applications/${id}/score`, scores),
  addComment: (id, comment) => api.post(`/admin/applications/${id}/comments`, { comment }),
  exportApplications: (params) =>
    api.get('/admin/export', { params, responseType: 'blob' }),
  getSettings: () => api.get('/admin/settings'),
  updateSettings: (data) => api.put('/admin/settings', data),
};

export default api;
